module.exports = __webpack_public_path__ + "img/jnt-cargo.83dcc757.jpg";